import React from 'react';

import H2 from '@sdk/components/ui/typography/H2';
import Text16 from '@sdk/components/ui/typography/Text16';
import Row from '@sdk/components/ui/spacing/Row';

import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext from '@sdk/lang/gettext';
import SignupRouteTile from '@sdk/login/components/SignupRouteTile';
import PlusSvg from '@sdk/assets/svg/UI/buttons/rounded/plus.svg';
import SyncSvg from '@sdk/assets/svg/UI/buttons/rounded/sync.svg';
import mobile from '@sdk/assets/images/web-login/mobile.png';

import { Layout } from '../components/Layout';

import { SideImg, MaxHeightImage, MainSection } from './LoginOrRegister.styles';

type Props = {
  onSignIn: () => void;
  onSignUp: () => void;
};

export const LoginOrRegister = ({ onSignIn, onSignUp }: Props) => (
  <Layout>
    <SideImg>
      <MaxHeightImage src={mobile} />
    </SideImg>
    <MainSection>
      <Row>
        <H2 themeColor={ThemeColorType.primaryText}>{gettext('Welcome to Sling!')}</H2>
      </Row>
      <Row top={10}>
        <Text16 themeColor={ThemeColorType.gray}>
          {gettext('How would you like to connect your Toast account with Sling?')}
        </Text16>
      </Row>
      <Row top={20}>
        <SignupRouteTile
          icon={<PlusSvg />}
          mainText={gettext('Create a new Sling account')}
          descriptionText={gettext('Set up a new account using data from Toast.')}
          onClick={onSignUp}
        />
      </Row>
      <Row top={20}>
        <SignupRouteTile
          icon={<SyncSvg />}
          mainText={gettext('Connect to an existing Sling account')}
          descriptionText={gettext('Sync Toast data to an existing account.')}
          onClick={onSignIn}
        />
      </Row>
    </MainSection>
  </Layout>
);
